
import {
  defineComponent,
  ref,
  computed,
  useStore,
  useAsync,
} from '@nuxtjs/composition-api'
import { Wishlist } from '~/assets/ts/items/wishlist'
import { AppointmentLink } from '~/assets/ts/appointment/AppointmentLink'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  props: {
    navData: {
      type: Object,
      required: true,
    },
  },
  emits: ['hide-navigation'],
  setup(props, { emit }) {
    const visibleMobileNavigation = ref('engagement')

    const toogleMobileNavigation = (navNode: string) => {
      visibleMobileNavigation.value =
        visibleMobileNavigation.value !== navNode ? navNode : ''
    }

    const navActive = computed(() => {
      if (visibleMobileNavigation.value) {
        const navCategory: string = visibleMobileNavigation.value.toLowerCase()
        return props.navData[navCategory]
      }
    })

    const hideNavi = () => {
      emit('hide-navigation', '')
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }

    const store = useStore()

    const itemsOnWishlist = computed(() => store.getters['wishlist/getNumber'])

    useAsync(() => {
      new Wishlist().getList().then((wishlist: any) => {
        store.commit('wishlist/setNumber', wishlist.length)
      })
    })

    const country = getCountryCode()

    const appointmentLink = new AppointmentLink().getAppointmentOverview()

    return {
      hideNavi,
      toogleMobileNavigation,
      navActive,
      visibleMobileNavigation,
      itemsOnWishlist,
      country,
      appointmentLink,
    }
  },
})
